import moment from 'moment';
import { RadioButtonGroup, TimePickerControl } from '../../../controls';
import { DateTimeValue } from '../../../../types/filters/DateTimeValue';
import { TimeOption } from '../../../../types/filters/TimeOption';
import { DateTimeStamp } from '../../../../types/primitives/DateTimeStamp';

interface TimeInputProps {
    date?: Date;
    timeOption?: TimeOption;
    label?: string;
    onChange: (value: DateTimeValue) => void;
}

const OptionsList = [
    { label: "Any time", value: TimeOption.AnyTime },
    { label: "Select time", value: TimeOption.CustomTime },
];

export function TimeInput({
    onChange,
    date,
    timeOption,
    label,
}: TimeInputProps) {
    // use function to avoid moment object mutation
    const selectedDate = () => date ? moment(date) : moment().startOf('day');

    const handleModeChange = (timeOption: TimeOption) => {
        onChange({
            date: selectedDate().startOf('day').toDate(),
            timeOption,
        });
    };

    const handleTimeChange = (time?: DateTimeStamp) => {
        if (time) {
            const momentTime = moment.utc(time);

            const date = selectedDate()
                .startOf('day')
                .hour(momentTime.hour())
                .minute(momentTime.minute())
                .toDate()

            onChange({ date, timeOption: TimeOption.CustomTime });
        }
    };

    return (
        <div className="form-item">
            <label className="form-label">{label}</label>
            <TimePickerControl
                time={timeOption === TimeOption.CustomTime
                    ? selectedDate().utcOffset(0, true).toISOString()
                    : null
                }
                placeholder='Any Time'
                minuteStep={15}
                onTimeChange={handleTimeChange}
            >
                {timePickerControls =>
                    <>
                        <div className="time-picker-radio-group">
                            <RadioButtonGroup
                                options={OptionsList}
                                value={timeOption || TimeOption.AnyTime}
                                onChange={handleModeChange}
                                disabled={false}
                            />
                        </div>
                        {timeOption === TimeOption.CustomTime && timePickerControls}
                    </>
                }
            </TimePickerControl>
        </div>
    );
}
